import EditEndDate from './edit_end_date'
import { reduxForm } from 'redux-form'
import { getI18n } from 'client/i18n'
import { endNowRemotely, updateRemotely } from 'redux/modules/campaign'
import { endDateValidators, maxDaysValidator } from 'lib/end_date_validators'
import { combine, required, futureDate } from 'lib/validators'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { endOfDay } from 'shared/helpers/datetime_helpers'
import {
  CROWDFUNDING_CAMPAIGN_MAX_DAYS,
  MONEY_POOLS_MAX_DAYS,
  POOLS_CAMPAIGN_TYPES,
} from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES
const i18n = getI18n('components/edit_glimpse/edit_end_date')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const ended = !campaign.can_chip_in
  const startDate = campaign.start_date
    ? new Date(campaign.start_date)
    : new Date()
  const endDate = campaign.end_date ? new Date(campaign.end_date) : undefined
  const campaignType = campaign.campaign_type
  let validators = []

  validators.push(required('endDate', i18n('end_date_required')))
  validators.push(...endDateValidators('endDate', i18n('invalid_date')))
  validators.push(futureDate('endDate', i18n('date_must_be_future')))

  if (campaignType === CROWD_FUNDING) {
    validators.push(
      maxDaysValidator(
        'endDate',
        startDate,
        CROWDFUNDING_CAMPAIGN_MAX_DAYS,
        i18n('invalid_date_limit_cf', {
          maxdays: CROWDFUNDING_CAMPAIGN_MAX_DAYS,
        })
      )
    )
  } else {
    validators.push(
      maxDaysValidator(
        'endDate',
        startDate,
        MONEY_POOLS_MAX_DAYS,
        i18n('invalid_date_limit', {
          maxDays: MONEY_POOLS_MAX_DAYS,
        })
      )
    )
  }

  return {
    validate: combine(...validators),
    ended,
    endDate,
    endable: !(ended || campaign.preview),
    initialValues: {
      endDate: ended || !endDate ? undefined : endOfDay(endDate),
    },
    campaignType,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, { end_date: formValues.endDate })
      )
    },
    onEndNow() {
      return dispatch(endNowRemotely(campaignId))
    },
  }
}

export default reduxForm(
  {
    form: 'edit_end_date',
    fields: ['endDate'],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditEndDate)
